export default __webpack_public_path__ + "static/self-5aa534228904c6e280ee2c0d0b1318ff.png";